let i18nConfig = window.i18nConfig;
if (!i18nConfig) {
  i18nConfig = require('/srv/src/main/utils/i18n').default;
}

export default i18nConfig;
